import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import Card from 'react-bootstrap/Card';
import axios from 'axios';
// import Cookies from 'js-cookie'; // Keep if needed
import { showToast as toast } from '../toastManager';
// import errorMessages from '../errorMessages.js'; // Keep if needed
import google_logo from "../images/google.png";
import meta_logo from "../images/meta.png";
// import Breadcrumbs from '../components/Breadcrumbs';

const Category = ({ ViewedPage, shop_domain, app_url, allowed_pages_json }) => {
    ViewedPage(28);
    const navigate = useNavigate();
    const location = useLocation();

    const initialCampaignData = location.state?.campaignData;
    const initialallTargeting = location.state?.allTargeting;
    console.log("initialallTargeting -",initialallTargeting)
    const [loading, setLoading] = useState(true);
    const [hoveredCardId, setHoveredCardId] = useState(null);
    const [categories, setCategories] = useState([]);
    const [integrationStatus, setIntegrationStatus] = useState({ is_meta_integrated: false, is_google_integrated: false });

    useEffect(() => {
        if (!initialCampaignData) {
            navigate('/campaign-summary');
            return;
        }

        const fetchIntegrationStatusAndBuildCategories = async () => {
            // Fetch meta and google integration status
            let is_meta_integrated = false;
            let is_google_integrated = false;
            try {
                const response = await axios.post(`${app_url}/api/facebook_and_google/get_integration_status`);
                if (response.data?.success) {
                    is_meta_integrated = response.data.data.is_meta_integrated;
                    is_google_integrated = response.data.data.is_google_integrated;
                    setIntegrationStatus({ is_meta_integrated, is_google_integrated });
                }
            } catch (error) {
                console.error("Error fetching integration status:", error);
            }

            // Get allowed pages for current shop
            const shop_key = shop_domain?.replace(".myshopify.com", "");
            const allowed_pages = allowed_pages_json && shop_key && allowed_pages_json[shop_key] ? Object.values(allowed_pages_json[shop_key]) : [4, 5];

            // Build categories based on permissions
            const availableCategories = [];

            // Add Keyword Personalization if user has permission (page ID 19)
            if (allowed_pages.includes(19)) {
                availableCategories.push({
                    id: 1,
                    title: 'Keyword\nPersonalization',
                    name: 'Keyword Personalization',
                    description: 'Personalize landing page for each keyword',
                    logo: google_logo,
                    locked: !is_google_integrated
                });
            }

            // Add Ads Personalization if user has permission (page ID 27)
            if (allowed_pages.includes(27)) {
                availableCategories.push({
                    id: 2,
                    title: 'Ads\nPersonalization',
                    name: 'Ads Personalization',
                    description: 'Personalize landing page for each ad',
                    logo: meta_logo,
                    locked: !is_meta_integrated
                });
            }

            // Always add Custom Campaign option
            availableCategories.push({
                id: 3,
                title: 'Custom\nCampaign',
                name: 'Custom Campaign',
                description: 'Personalize for any channel',
                logo: null,
                locked: false
            });

            setCategories(availableCategories);
            setLoading(false);
        };

        fetchIntegrationStatusAndBuildCategories();
    }, [initialCampaignData, navigate, allowed_pages_json, shop_domain, app_url]);

    // Logic Updated: Handle Category Selection
    const handleCategorySelect = (selectedCategory) => {
        if (selectedCategory.locked) {
            const platform = selectedCategory.id === 1 ? 'Google' : 'Meta';
            toast.error(`Please complete ${platform} integration first to use ${selectedCategory.name}.`);
            return;
        }

        if (!initialCampaignData) {
            toast.error("Error: Campaign data is missing.");
            console.error("handleCategorySelect called without initialCampaignData");
            return;
        }

        const updatedCampaignData = {
            ...initialCampaignData,
            category: selectedCategory.name
        };
        console.log("Category Selected:", selectedCategory.name);
        console.log("Navigating to PersonalizationCampaign with:", updatedCampaignData);
        // Navigate to Personalization Campaign page and pass the updated data
        navigate('/personalization-campaign', {
            state: {
                campaignData: updatedCampaignData,
                allTargeting: initialallTargeting,
                previousPage: 'category' // Add this to track where we came from
            }
        });
    };


    const handleMouseEnter = (categoryId) => {
        setHoveredCardId(categoryId);
    };

    const handleMouseLeave = () => {
        setHoveredCardId(null);
    };

    // Logic Added: Show loading or redirect message if needed
    if (loading || !initialCampaignData) {
        return (
            <div className='main-container' style={{ position: "relative" }}>
                <div className="text-center mt-5">
                    {loading && <Spinner animation="border" role="status"><span className="visually-hidden">Loading...</span></Spinner>}
                    {!loading && !initialCampaignData && <p>Redirecting...</p>}
                </div>
            </div>
        )
    }



    return (
        <div className='main-container' style={{ position: "relative" }}>
            {!shop_domain ? (
                <div className='go_to_shopify_admin_div'>
                    <h5 style={{ display: 'inline-block' }}>!! Go to Shopify Admin and open our app !!</h5>
                </div>
            ) : (
                <>
                    {!loading ? (
                        <>
                            {/* <Breadcrumbs campaignData={initialCampaignData} /> */}
                            {/* Original Title with Back Button */}
                            <div className='main-title opportunities-header mt-4 mx-2'>
                                <div className="d-flex align-items-center justify-content-between" style={{ width: '100%' }}>
                                    <h2 className="mb-0">Category</h2>
                                </div>
                            </div>

                            {/* Original Card Layout */}
                            <div className='main-accordion-body mt-4'>
                                <Container fluid>
                                    <Row className='g-4'>
                                        {categories.map((category) => (
                                            <Col key={category.id} xs={12} sm={6} md={4}>
                                                <Card
                                                    className='h-100'
                                                    onClick={() => handleCategorySelect(category)}
                                                    onMouseEnter={() => !category.locked && handleMouseEnter(category.id)}
                                                    onMouseLeave={handleMouseLeave}
                                                    style={{
                                                        cursor: category.locked ? 'not-allowed' : 'pointer',
                                                        border: '1px solid #dee2e6',
                                                        borderRadius: '4px',
                                                        height: '100%',
                                                        minHeight: '180px',
                                                        transition: 'all 0.3s ease',
                                                        transform: !category.locked && hoveredCardId === category.id ? 'translateY(-8px)' : 'translateY(0)',
                                                        boxShadow: !category.locked && hoveredCardId === category.id ? '0 8px 24px rgba(53, 79, 136, 0.2)' : 'none',
                                                        borderColor: !category.locked && hoveredCardId === category.id ? '#354F88' : '#dee2e6',
                                                        // opacity: category.locked ? 0.6 : 1,
                                                        position: 'relative'
                                                    }}
                                                >
                                                    <Card.Body className='p-3 d-flex flex-column'>
                                                        <div className='d-flex justify-content-between align-items-start mb-3'>
                                                            <Card.Title
                                                                className='mb-0'
                                                                style={{
                                                                    fontSize: '18px',
                                                                    fontWeight: 'bold',
                                                                    // color: category.locked ? '#999' : (hoveredCardId === category.id ? '#354F88' : 'inherit'),
                                                                    transition: 'color 0.3s ease',
                                                                    whiteSpace: 'pre-wrap'
                                                                }}
                                                            >
                                                                {category.title.split('\n').map((line, idx) => (
                                                                    <div key={idx}>{line}</div>
                                                                ))}
                                                            </Card.Title>

                                                            <div className='d-flex align-items-center gap-2'>
                                                                {category.locked && (
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000000" className="bi bi-lock" viewBox="0 0 16 16">
                                                                        <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
                                                                    </svg>
                                                                )}
                                                                {category.logo && (
                                                                    <img
                                                                        src={category.logo}
                                                                        alt={category.title.replace('\n', ' ')}
                                                                        style={{
                                                                            width: '20px',
                                                                            height: '20px',
                                                                            transform: !category.locked && hoveredCardId === category.id ? 'scale(1.1)' : 'scale(1)',
                                                                            transition: 'transform 0.3s ease',
                                                                            // filter: category.locked ? 'grayscale(100%)' : 'none'
                                                                        }}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                        <Card.Text
                                                            style={{
                                                                fontSize: '14px',
                                                                // color: category.locked ? '#999' : '#555',
                                                                marginTop: 'auto',
                                                                marginBottom: 'auto'
                                                            }}
                                                        >
                                                            {category.description}
                                                        </Card.Text>
                                                        {category.locked ? (
                                                            <div className="mt-3">
                                                                <span style={{ fontSize: '12px' }}>
                                                                    Integration required
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            hoveredCardId === category.id && (
                                                                <div className="mt-3 text-end">
                                                                    <span
                                                                        style={{
                                                                            color: '#354F88',
                                                                            fontSize: '14px',
                                                                            fontWeight: 'bold'
                                                                        }}
                                                                    >
                                                                        Select →
                                                                    </span>
                                                                </div>
                                                            )
                                                        )}
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                </Container>
                            </div>
                            <div className='mx-2 mt-3'>
                                <div className="d-flex align-items-center gap-2">
                                    <button
                                        className='back-button btn-height'
                                        onClick={() => navigate('/campaign-summary')}
                                        style={{ display: 'flex', alignItems: 'center' }}
                                    >
                                        Back
                                    </button>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="text-center mt-5">
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default Category;